//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import moment from 'moment';
import { BaseHttpClient } from './base-http-client';
export class AdminDashboardRolesHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getDashboardRoles(version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/dashboardroles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardRoles(_response);
        });
    }
    processGetDashboardRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(DashboardRole.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminDashboardUserHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createDashboardUser(organizationId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateDashboardUser(_response);
        });
    }
    processCreateDashboardUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateDashboardUserResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param term (optional)
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getDashboardUsersList(organizationId, orderBy_OrderByAsc, orderBy_OrderBy, term, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardUsersList(_response);
        });
    }
    processGetDashboardUsersList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListDashboardUsersResultEntryPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDashboardUserInformation(organizationId, dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardUserInformation(_response);
        });
    }
    processGetDashboardUserInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDashboardUserInformationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateDashboardUser(organizationId, dashboardUserId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateDashboardUser(_response);
        });
    }
    processUpdateDashboardUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteDashboardUser(organizationId, dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteDashboardUser(_response);
        });
    }
    processDeleteDashboardUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    restoreDashboardUser(organizationId, dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRestoreDashboardUser(_response);
        });
    }
    processRestoreDashboardUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminDashboardUserInviteHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    sendDashboardUserInvite(organizationId, dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/invite/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendDashboardUserInvite(_response);
        });
    }
    processSendDashboardUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    revokeDashboardUserInvite(organizationId, dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/users/invite/{dashboardUserId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRevokeDashboardUserInvite(_response);
        });
    }
    processRevokeDashboardUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminDashboardUserRegistrationHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get dashboard user information before confirm the registration.
     * @param value (optional)
     * @param inviteToken Dashboard user invitation token.
     */
    getDashboardUserInvitationInfo(value, inviteToken, version, email) {
        let url_ = this.baseUrl + "/admin/v{version}/users/{email}/registration/{inviteToken}?";
        if (inviteToken === undefined || inviteToken === null)
            throw new Error("The parameter 'inviteToken' must be defined.");
        url_ = url_.replace("{inviteToken}", encodeURIComponent("" + inviteToken));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (value !== undefined && value !== null)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardUserInvitationInfo(_response);
        });
    }
    processGetDashboardUserInvitationInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Dashboard user registration confirmation.
     * @param value (optional)
     * @param inviteToken Dashboard user invitation token.
     * @param body (optional)
     */
    confirmDashboardUserRegistration(value, inviteToken, version, email, body) {
        let url_ = this.baseUrl + "/admin/v{version}/users/{email}/registration/{inviteToken}/confirm?";
        if (inviteToken === undefined || inviteToken === null)
            throw new Error("The parameter 'inviteToken' must be defined.");
        url_ = url_.replace("{inviteToken}", encodeURIComponent("" + inviteToken));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (value !== undefined && value !== null)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processConfirmDashboardUserRegistration(_response);
        });
    }
    processConfirmDashboardUserRegistration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminDashboardUserTitlesHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getDashboardUserTitles(version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/users/titles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardUserTitles(_response);
        });
    }
    processGetDashboardUserTitles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(DashboardUserTitleOutputDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrganizationHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Creates organization
     * @param body (optional) Organization info
     * @return Success
     */
    createOrganization(version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateOrganization(_response);
        });
    }
    processCreateOrganization(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * List organizations
     * @param remotePatientMonitoringProviderId (optional)
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param filterBy (optional)
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getOrganizationsList(remotePatientMonitoringProviderId, orderBy_OrderByAsc, orderBy_OrderBy, filterBy, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (remotePatientMonitoringProviderId !== undefined && remotePatientMonitoringProviderId !== null)
            url_ += "RemotePatientMonitoringProviderId=" + encodeURIComponent("" + remotePatientMonitoringProviderId) + "&";
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (filterBy !== undefined && filterBy !== null)
            url_ += "FilterBy=" + encodeURIComponent("" + filterBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrganizationsList(_response);
        });
    }
    processGetOrganizationsList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return throwException("Success", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDtoPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update organization info
     * @param organizationId Organization id
     * @param body (optional) Organization info
     * @return Success
     */
    updateOrganization(organizationId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateOrganization(_response);
        });
    }
    processUpdateOrganization(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deactivates organization
     * @return Success
     */
    deleteOrganization(organizationId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteOrganization(_response);
        });
    }
    processDeleteOrganization(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restores organization
     * @param organizationId Organization id
     * @return Success
     */
    restoreOrganization(organizationId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRestoreOrganization(_response);
        });
    }
    processRestoreOrganization(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * List the organization channels available to assign to an organization
     * @return Success
     */
    getOrganizationChannels(version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/channels";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrganizationChannels(_response);
        });
    }
    processGetOrganizationChannels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrganizationChannelDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get organization info
     * @param organizationId Organization id
     * @return Success
     */
    getOrganization(organizationId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrganization(_response);
        });
    }
    processGetOrganization(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    searchOrganizations(term, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/search/{term}";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined.");
        url_ = url_.replace("{term}", encodeURIComponent("" + term));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchOrganizations(_response);
        });
    }
    processSearchOrganizations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrganizationNameDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxCareUserHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getOrpyxCareUserInformation(dashboardUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/users/orpyxcare/{dashboardUserId}";
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxCareUserInformation(_response);
        });
    }
    processGetOrpyxCareUserInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetOrpyxCareUserInformationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateOrpyxCareUser(dashboardUserId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/users/orpyxcare/{dashboardUserId}";
        if (dashboardUserId === undefined || dashboardUserId === null)
            throw new Error("The parameter 'dashboardUserId' must be defined.");
        url_ = url_.replace("{dashboardUserId}", encodeURIComponent("" + dashboardUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateOrpyxCareUser(_response);
        });
    }
    processUpdateOrpyxCareUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param term (optional)
     * @param permissionsFilter (optional)
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getOrpyxCareUsersList(orderBy_OrderByAsc, orderBy_OrderBy, term, permissionsFilter, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/users/orpyxcare?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (permissionsFilter === null)
            throw new Error("The parameter 'permissionsFilter' cannot be null.");
        else if (permissionsFilter !== undefined)
            url_ += "PermissionsFilter=" + encodeURIComponent("" + permissionsFilter) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxCareUsersList(_response);
        });
    }
    processGetOrpyxCareUsersList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListOrpyxCareUsersResultEntryPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxRolesHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * List available roles.
     * @return Success
     */
    getOrpyxRoles(version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/roles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxRoles(_response);
        });
    }
    processGetOrpyxRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrpyxRoleDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxUserProfileHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Current user profile.
     * @return Success
     */
    getOrpyxUserProfile(version) {
        let url_ = this.baseUrl + "/admin/v{version}/profile/me";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxUserProfile(_response);
        });
    }
    processGetOrpyxUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxUsersHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create orpyx user with roles.
     * @param body (optional)
     * @return Success
     */
    createOrpyxUser(version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateOrpyxUser(_response);
        });
    }
    processCreateOrpyxUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * List orpyx users.
     * @param term (optional) <br>Search usesrs by
    <br>- FirstName or LastName
    <br>- Pair of FirstName and LastName
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param orpyxRoleType (optional) <br>Search usesrs with OrpyxRole
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getOrpyxUsersList(term, orderBy_OrderByAsc, orderBy_OrderBy, orpyxRoleType, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (orpyxRoleType === null)
            throw new Error("The parameter 'orpyxRoleType' cannot be null.");
        else if (orpyxRoleType !== undefined)
            url_ += "OrpyxRoleType=" + encodeURIComponent("" + orpyxRoleType) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxUsersList(_response);
        });
    }
    processGetOrpyxUsersList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDtoPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Returns specified orpyx user information.
     * @param orpyxUserId Orpyx user id
     * @return Success
     */
    getOrpyxUserInformation(orpyxUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrpyxUserInformation(_response);
        });
    }
    processGetOrpyxUserInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deactivates orpyx user.
     * @param orpyxUserId Orpyx user id
     * @return Success
     */
    deleteOrpyxUser(orpyxUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteOrpyxUser(_response);
        });
    }
    processDeleteOrpyxUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restores orpyx user.
     * @param orpyxUserId Orpyx user id
     * @return Success
     */
    restoreOrpyxUser(orpyxUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRestoreOrpyxUser(_response);
        });
    }
    processRestoreOrpyxUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates orpyx user info.
     * @param orpyxUserId Orpyx user id
     * @param body (optional) Update data
     * @return Success
     */
    updateOrpyxUser(orpyxUserId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateOrpyxUser(_response);
        });
    }
    processUpdateOrpyxUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxUsersInviteHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Sends invitation to orpyx user
     * @param orpyxUserId Orpyx user id
     * @return Success
     */
    sendOrpyxUserInvite(orpyxUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/invite/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendOrpyxUserInvite(_response);
        });
    }
    processSendOrpyxUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Revoke orpyx user invitation.
    Makes an invitation link sent to the user invalid.
     * @return Success
     */
    revokeOrpyxUserInvite(orpyxUserId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/invite/{orpyxUserId}";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRevokeOrpyxUserInvite(_response);
        });
    }
    processRevokeOrpyxUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrpyxUserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminOrpyxUsersRolesHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Assigns role to the orpyx user.
     * @param orpyxUserId Orpyx user id
     * @param roleType (optional) Role
     * @return Success
     */
    assignOrpyxUserRole(orpyxUserId, roleType, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}/roles?";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (roleType === null)
            throw new Error("The parameter 'roleType' cannot be null.");
        else if (roleType !== undefined)
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAssignOrpyxUserRole(_response);
        });
    }
    processAssignOrpyxUserRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssignOrpyxUserRolesResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param roleType (optional)
     * @return Success
     */
    revokeOrpyxUserRole(orpyxUserId, roleType, version) {
        let url_ = this.baseUrl + "/admin/v{version}/orpyx/users/{orpyxUserId}/roles?";
        if (orpyxUserId === undefined || orpyxUserId === null)
            throw new Error("The parameter 'orpyxUserId' must be defined.");
        url_ = url_.replace("{orpyxUserId}", encodeURIComponent("" + orpyxUserId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (roleType === null)
            throw new Error("The parameter 'roleType' cannot be null.");
        else if (roleType !== undefined)
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRevokeOrpyxUserRole(_response);
        });
    }
    processRevokeOrpyxUserRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RevokeOrpyxUserRoleResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminPatientHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new product for a patient.
     * @param patientId Patient a product is created for.
     * @param body (optional) New product data.
     * @return Success
     */
    createPatientProduct(patientId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/{patientId}/products";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreatePatientProduct(_response);
        });
    }
    processCreatePatientProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProductResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * List patient products.
     * @param patientId Patient for whom products are listing.
     * @return Success
     */
    getPatientProductsList(patientId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/{patientId}/products";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientProductsList(_response);
        });
    }
    processGetPatientProductsList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ListProductsResultEntry.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminPatientsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Return patient information.
     * @param organizationId Patient organization id.
     * @param patientId Patient id.
     * @return Success
     */
    getPatientInformation(organizationId, patientId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/patients/{patientId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientInformation(_response);
        });
    }
    processGetPatientInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param organizationId (optional)
     * @param paging_Offset (optional)
     * @param paging_Count (optional)
     * @param term (optional) <br>ClientPatientIdentifier or Patient Last Name
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param statuses (optional) <br>Filter patients by portal status
     * @return Success
     */
    getPatients(organizationId, paging_Offset, paging_Count, term, orderBy_OrderByAsc, orderBy_OrderBy, statusIds, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/patients?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (paging_Offset === null)
            throw new Error("The parameter 'paging_Offset' cannot be null.");
        else if (paging_Offset !== undefined)
            url_ += "Paging.Offset=" + encodeURIComponent("" + paging_Offset) + "&";
        if (paging_Count === null)
            throw new Error("The parameter 'paging_Count' cannot be null.");
        else if (paging_Count !== undefined)
            url_ += "Paging.Count=" + encodeURIComponent("" + paging_Count) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (statusIds !== undefined && statusIds !== null)
            statusIds.forEach(item_ => { url_ += "StatusIds=" + encodeURIComponent("" + item_) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatients(_response);
        });
    }
    processGetPatients(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientsListResultPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param organizationId (optional)
     * @param term (optional) <br>ClientPatientIdentifier or Patient Last Name
     * @return Success
     */
    searchPatients(organizationId, term, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/patients/search?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchPatients(_response);
        });
    }
    processSearchPatients(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PatientOutputDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create new patient in organization.
     * @param organizationId Patient organization id.
     * @param body (optional) New patient info.
     * @return Success
     */
    createPatient(organizationId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/patients";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreatePatient(_response);
        });
    }
    processCreatePatient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update patient information.
     * @param body (optional)
     * @return Success
     */
    updatePatient(organizationId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/patients";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdatePatient(_response);
        });
    }
    processUpdatePatient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deactivate patient.
     * @param organizationId Patient organization id.
     * @param patientId (optional) Patient id.
     * @return Success
     */
    deletePatient(organizationId, patientId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/patients?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeletePatient(_response);
        });
    }
    processDeletePatient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Active patient.
     * @param organizationId Patient organization id.
     * @param patientId (optional) Patient id.
     * @return Success
     */
    restorePatient(organizationId, patientId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/organizations/{organizationId}/patients?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRestorePatient(_response);
        });
    }
    processRestorePatient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminPatientsRawStatisticsExporterHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param saveInsolesToSeparateFiles (optional)
     * @param begin (optional)
     * @param end (optional)
     * @return Success
     */
    exportRawPatientTemperatureStatistics(saveInsolesToSeparateFiles, begin, end, insolesSerialNumbers, version) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/statistics?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (saveInsolesToSeparateFiles === null)
            throw new Error("The parameter 'saveInsolesToSeparateFiles' cannot be null.");
        else if (saveInsolesToSeparateFiles !== undefined)
            url_ += "SaveInsolesToSeparateFiles=" + encodeURIComponent("" + saveInsolesToSeparateFiles) + "&";
        if (begin !== undefined && begin !== null)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (insolesSerialNumbers === undefined || insolesSerialNumbers === null)
            throw new Error("The parameter 'insolesSerialNumbers' must be defined and cannot be null.");
        else
            insolesSerialNumbers && insolesSerialNumbers.forEach(item => { url_ += "InsolesSerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExportRawPatientTemperatureStatistics(_response);
        });
    }
    processExportRawPatientTemperatureStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminPatientStatusTypesHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Return the seeded patient status types, in dropdown display order.
     * @return Success
     */
    getPatientStatusTypes(version) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/status/types";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientStatusTypes(_response);
        });
    }
    processGetPatientStatusTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PatientStatusType.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminPhiAuditLogHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param begin (optional)
     * @param end (optional)
     * @param organizationId (optional)
     * @param actorType (optional)
     * @param accessType (optional)
     * @param actorIdentifier (optional)
     * @param patientIdentifier (optional)
     * @param patientOptions (optional)
     * @return Success
     */
    audit(begin, end, organizationId, actorType, accessType, actorIdentifier, patientIdentifier, patientOptions, version) {
        let url_ = this.baseUrl + "/admin/v{version}/audit?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (actorType === null)
            throw new Error("The parameter 'actorType' cannot be null.");
        else if (actorType !== undefined)
            url_ += "ActorType=" + encodeURIComponent("" + actorType) + "&";
        if (accessType === null)
            throw new Error("The parameter 'accessType' cannot be null.");
        else if (accessType !== undefined)
            url_ += "AccessType=" + encodeURIComponent("" + accessType) + "&";
        if (actorIdentifier !== undefined && actorIdentifier !== null)
            url_ += "ActorIdentifier=" + encodeURIComponent("" + actorIdentifier) + "&";
        if (patientIdentifier !== undefined && patientIdentifier !== null)
            url_ += "PatientIdentifier=" + encodeURIComponent("" + patientIdentifier) + "&";
        if (patientOptions === null)
            throw new Error("The parameter 'patientOptions' cannot be null.");
        else if (patientOptions !== undefined)
            url_ += "PatientOptions=" + encodeURIComponent("" + patientOptions) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAudit(_response);
        });
    }
    processAudit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminProductHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Update product's serial number.
    Insoles serials number are updated by another endpoint.
     * @param productId Product to update. This is the internal Id, not the product serial number.
     * @param body (optional) Data to update.
     * @return Success
     */
    updatePatientProduct(patientId, productId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/{patientId}/products/{productId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdatePatientProduct(_response);
        });
    }
    processUpdatePatientProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateProductResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create new insole for the product.
     * @param productId Product an insole is created for. This is the internal Id, not the product serial number.
     * @param body (optional) Insole's data.
     * @return Success
     */
    addInsoleToPatientProduct(patientId, productId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/{patientId}/products/{productId}/insoles";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddInsoleToPatientProduct(_response);
        });
    }
    processAddInsoleToPatientProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddInsoleResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove an insole from product.
     * @param productId Product an insole is removed from. This is the internal Id, not the product serial number.
     * @param insoleId Insole to delete. This is the internal Id, not the insole serial number.
     * @return Success
     */
    removeInsoleFromPatientProduct(patientId, productId, insoleId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/{patientId}/products/{productId}/insoles/{insoleId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (insoleId === undefined || insoleId === null)
            throw new Error("The parameter 'insoleId' must be defined.");
        url_ = url_.replace("{insoleId}", encodeURIComponent("" + insoleId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRemoveInsoleFromPatientProduct(_response);
        });
    }
    processRemoveInsoleFromPatientProduct(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemoveInsoleResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param term (optional)
     * @return Success
     */
    searchPatientInsoles(term, version) {
        let url_ = this.baseUrl + "/admin/v{version}/patients/products/insoles?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchPatientInsoles(_response);
        });
    }
    processSearchPatientInsoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchPatientInsolesResponseEntry.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AdminRemotePatientMonitoringProviderHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createRemotePatientMonitoringProvider(version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateRemotePatientMonitoringProvider(_response);
        });
    }
    processCreateRemotePatientMonitoringProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemotePatientMonitoringProviderOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param term (optional)
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getRemotePatientMonitoringProviderList(term, orderBy_OrderByAsc, orderBy_OrderBy, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (orderBy_OrderByAsc === null)
            throw new Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetRemotePatientMonitoringProviderList(_response);
        });
    }
    processGetRemotePatientMonitoringProviderList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemotePatientMonitoringProviderOutputDtoPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateRemotePatientMonitoringProvider(remotePatientMonitoringProviderId, version, body) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider/{remotePatientMonitoringProviderId}";
        if (remotePatientMonitoringProviderId === undefined || remotePatientMonitoringProviderId === null)
            throw new Error("The parameter 'remotePatientMonitoringProviderId' must be defined.");
        url_ = url_.replace("{remotePatientMonitoringProviderId}", encodeURIComponent("" + remotePatientMonitoringProviderId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateRemotePatientMonitoringProvider(_response);
        });
    }
    processUpdateRemotePatientMonitoringProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemotePatientMonitoringProviderOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteRemotePatientMonitoringProvider(remotePatientMonitoringProviderId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider/{remotePatientMonitoringProviderId}";
        if (remotePatientMonitoringProviderId === undefined || remotePatientMonitoringProviderId === null)
            throw new Error("The parameter 'remotePatientMonitoringProviderId' must be defined.");
        url_ = url_.replace("{remotePatientMonitoringProviderId}", encodeURIComponent("" + remotePatientMonitoringProviderId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteRemotePatientMonitoringProvider(_response);
        });
    }
    processDeleteRemotePatientMonitoringProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemotePatientMonitoringProviderOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getRemotePatientMonitoringProvider(remotePatientMonitoringProviderId, version) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider/{remotePatientMonitoringProviderId}";
        if (remotePatientMonitoringProviderId === undefined || remotePatientMonitoringProviderId === null)
            throw new Error("The parameter 'remotePatientMonitoringProviderId' must be defined.");
        url_ = url_.replace("{remotePatientMonitoringProviderId}", encodeURIComponent("" + remotePatientMonitoringProviderId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetRemotePatientMonitoringProvider(_response);
        });
    }
    processGetRemotePatientMonitoringProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemotePatientMonitoringProviderOutputDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    searchRemotePatientMonitoringProvider(term, offset, count, version) {
        let url_ = this.baseUrl + "/admin/v{version}/rpm-provider/search/{term}?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined.");
        url_ = url_.replace("{term}", encodeURIComponent("" + term));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchRemotePatientMonitoringProvider(_response);
        });
    }
    processSearchRemotePatientMonitoringProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RemotePatientMonitoringProviderOutputDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export var DashboardRoleType;
(function (DashboardRoleType) {
    DashboardRoleType["BasicAccess"] = "BasicAccess";
    DashboardRoleType["AllOrganization"] = "AllOrganization";
})(DashboardRoleType || (DashboardRoleType = {}));
export class DashboardRole {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dashboardRoleId = _data["dashboardRoleId"] !== undefined ? _data["dashboardRoleId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.role = _data["role"] !== undefined ? _data["role"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardRole();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardRoleId"] = this.dashboardRoleId !== undefined ? this.dashboardRoleId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["role"] = this.role !== undefined ? this.role : null;
        return data;
    }
}
export var DashboardUserTitleType;
(function (DashboardUserTitleType) {
    DashboardUserTitleType["Other"] = "Other";
    DashboardUserTitleType["MedicalDoctor"] = "MedicalDoctor";
    DashboardUserTitleType["Podiatrist"] = "Podiatrist";
    DashboardUserTitleType["RegisteredNurse"] = "RegisteredNurse";
    DashboardUserTitleType["NursePractitioner"] = "NursePractitioner";
})(DashboardUserTitleType || (DashboardUserTitleType = {}));
export class CreateDashboardUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.titleType = _data["titleType"] !== undefined ? _data["titleType"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDashboardUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["titleType"] = this.titleType !== undefined ? this.titleType : null;
        return data;
    }
}
export var OperationResultCode;
(function (OperationResultCode) {
    OperationResultCode["UnknownError"] = "UnknownError";
    OperationResultCode["Successfully"] = "Successfully";
    OperationResultCode["Skipped"] = "Skipped";
    OperationResultCode["NoContent"] = "NoContent";
    OperationResultCode["InvalidData"] = "InvalidData";
    OperationResultCode["InvalidFilter"] = "InvalidFilter";
    OperationResultCode["PatientIdentifierIsExist"] = "PatientIdentifierIsExist";
    OperationResultCode["AuthorizationRequired"] = "AuthorizationRequired";
    OperationResultCode["InvalidAuthorizationToken"] = "InvalidAuthorizationToken";
    OperationResultCode["InvalidB2CObjectId"] = "InvalidB2CObjectId";
    OperationResultCode["Unauthorized"] = "Unauthorized";
    OperationResultCode["MethodNotAvailableToCall"] = "MethodNotAvailableToCall";
    OperationResultCode["EmailIsTaken"] = "EmailIsTaken";
    OperationResultCode["DataBaseError"] = "DataBaseError";
    OperationResultCode["StorageException"] = "StorageException";
    OperationResultCode["ExceptionError"] = "ExceptionError";
    OperationResultCode["NetworkError"] = "NetworkError";
    OperationResultCode["StorageEntityHasInitializationError"] = "StorageEntityHasInitializationError";
    OperationResultCode["IOError"] = "IOError";
    OperationResultCode["NotImplemented"] = "NotImplemented";
    OperationResultCode["NotSupported"] = "NotSupported";
    OperationResultCode["AzureTableAccessError"] = "AzureTableAccessError";
    OperationResultCode["PatientNotFound"] = "PatientNotFound";
    OperationResultCode["PatientNotActive"] = "PatientNotActive";
    OperationResultCode["PatientsNotFound"] = "PatientsNotFound";
    OperationResultCode["OrganizationNotFound"] = "OrganizationNotFound";
    OperationResultCode["PatientDeleted"] = "PatientDeleted";
    OperationResultCode["ActionRequiredAlertDoesntBelongToPatient"] = "ActionRequiredAlertDoesntBelongToPatient";
    OperationResultCode["OrganizationNameIsExist"] = "OrganizationNameIsExist";
    OperationResultCode["ActivityLogReportNotFound"] = "ActivityLogReportNotFound";
    OperationResultCode["MobileUserForPatientNotFound"] = "MobileUserForPatientNotFound";
    OperationResultCode["MobileUserNotFound"] = "MobileUserNotFound";
    OperationResultCode["UserAlertNotFound"] = "UserAlertNotFound";
    OperationResultCode["CarePractitionerReportActionNotFound"] = "CarePractitionerReportActionNotFound";
    OperationResultCode["DashboardUserAlreadyConfirmed"] = "DashboardUserAlreadyConfirmed";
    OperationResultCode["DashboardUserTitleNotFound"] = "DashboardUserTitleNotFound";
    OperationResultCode["DashboardUserNotFound"] = "DashboardUserNotFound";
    OperationResultCode["InvalidConfirmationToken"] = "InvalidConfirmationToken";
    OperationResultCode["DashboardUserHasNotBeenInvited"] = "DashboardUserHasNotBeenInvited";
    OperationResultCode["DashboardUserAlreadyRegistered"] = "DashboardUserAlreadyRegistered";
    OperationResultCode["DashboardUserInviteAlreadyRevoked"] = "DashboardUserInviteAlreadyRevoked";
    OperationResultCode["OrpyxRoleNotFound"] = "OrpyxRoleNotFound";
    OperationResultCode["AtLeastOneRoleIsRequired"] = "AtLeastOneRoleIsRequired";
    OperationResultCode["OrpyxUserNotFound"] = "OrpyxUserNotFound";
    OperationResultCode["OrpyxUserRoleAlreadyAssigned"] = "OrpyxUserRoleAlreadyAssigned";
    OperationResultCode["OrpyxUserRoleNotFound"] = "OrpyxUserRoleNotFound";
    OperationResultCode["OrpyxUserRoleOwnedByAnotherUser"] = "OrpyxUserRoleOwnedByAnotherUser";
    OperationResultCode["OrpyxUserRoleAlreadyRevoked"] = "OrpyxUserRoleAlreadyRevoked";
    OperationResultCode["DashboardUserAlreadyDeleted"] = "DashboardUserAlreadyDeleted";
    OperationResultCode["ProductNotFound"] = "ProductNotFound";
    OperationResultCode["ProductHasSameInsole"] = "ProductHasSameInsole";
    OperationResultCode["ProductHasSameSideInsole"] = "ProductHasSameSideInsole";
    OperationResultCode["InsoleSerialNumberIsTaken"] = "InsoleSerialNumberIsTaken";
    OperationResultCode["ProductWithSerialNumberAlreadyExists"] = "ProductWithSerialNumberAlreadyExists";
    OperationResultCode["NothingToRevoke"] = "NothingToRevoke";
    OperationResultCode["OrpyxUserRolesHasDuplicates"] = "OrpyxUserRolesHasDuplicates";
    OperationResultCode["OrpyxUserAlreadyDeleted"] = "OrpyxUserAlreadyDeleted";
    OperationResultCode["OrpyxUserAlreadyConfirmed"] = "OrpyxUserAlreadyConfirmed";
    OperationResultCode["ProductNotContainsInsole"] = "ProductNotContainsInsole";
    OperationResultCode["AtLeastOneInsoleInProductRequired"] = "AtLeastOneInsoleInProductRequired";
    OperationResultCode["NullOrEmptyEmailIsNotAllowed"] = "NullOrEmptyEmailIsNotAllowed";
    OperationResultCode["PatientNotDeleted"] = "PatientNotDeleted";
    OperationResultCode["OrpyxUserNotDeleted"] = "OrpyxUserNotDeleted";
    OperationResultCode["OrganizationDeleted"] = "OrganizationDeleted";
    OperationResultCode["OrganizationNotDeleted"] = "OrganizationNotDeleted";
    OperationResultCode["DashboardUserNotDeleted"] = "DashboardUserNotDeleted";
    OperationResultCode["ActionRequiredAlertNotFound"] = "ActionRequiredAlertNotFound";
    OperationResultCode["WrongPlantarTemperatureLog"] = "WrongPlantarTemperatureLog";
    OperationResultCode["RemotePatientMonitoringProviderNotFound"] = "RemotePatientMonitoringProviderNotFound";
    OperationResultCode["RemotePatientMonitoringProviderExist"] = "RemotePatientMonitoringProviderExist";
    OperationResultCode["InsoleSnNotFound"] = "InsoleSnNotFound";
    OperationResultCode["InsoleSnIsInvalid"] = "InsoleSnIsInvalid";
    OperationResultCode["InsoleMismatch"] = "InsoleMismatch";
    OperationResultCode["ShoePodIdNotRegistered"] = "ShoePodIdNotRegistered";
    OperationResultCode["FailedCreateAzureUser"] = "FailedCreateAzureUser";
    OperationResultCode["InvalidAzureB2CObjectId"] = "InvalidAzureB2CObjectId";
    OperationResultCode["InvalidInsertType"] = "InvalidInsertType";
    OperationResultCode["InvalidRpmVer"] = "InvalidRpmVer";
    OperationResultCode["RpmServiceProviderNotFound"] = "RpmServiceProviderNotFound";
    OperationResultCode["InvalidInsertSide"] = "InvalidInsertSide";
    OperationResultCode["ShoePodIdInsertIdMismatch"] = "ShoePodIdInsertIdMismatch";
    OperationResultCode["RpmFileFailedToParse"] = "RpmFileFailedToParse";
    OperationResultCode["RpmFileTimeStatusCorrupt"] = "RpmFileTimeStatusCorrupt";
    OperationResultCode["RpmOutdatedTimestamp"] = "RpmOutdatedTimestamp";
    OperationResultCode["HeartbeatInvalidVer"] = "HeartbeatInvalidVer";
    OperationResultCode["HeartbeatFileFailedToParse"] = "HeartbeatFileFailedToParse";
    OperationResultCode["DotDataFilesNoLongerSupported"] = "DotDataFilesNoLongerSupported";
    OperationResultCode["RpmTimestampBeforeReleaseDate"] = "RpmTimestampBeforeReleaseDate";
    OperationResultCode["InvalidNumberOfTemperatureSensors"] = "InvalidNumberOfTemperatureSensors";
    OperationResultCode["FileProcessedWithErrors"] = "FileProcessedWithErrors";
    OperationResultCode["RecordMissingTemperatureData"] = "RecordMissingTemperatureData";
    OperationResultCode["RecordMissingAlertData"] = "RecordMissingAlertData";
    OperationResultCode["RecordMissingStepCountData"] = "RecordMissingStepCountData";
    OperationResultCode["InvalidNumberOfPressureReadings"] = "InvalidNumberOfPressureReadings";
})(OperationResultCode || (OperationResultCode = {}));
export class OperationError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OperationError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    }
}
export var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus["NotActivated"] = "NotActivated";
    UserAccountStatus["Activated"] = "Activated";
    UserAccountStatus["Deactivated"] = "Deactivated";
})(UserAccountStatus || (UserAccountStatus = {}));
export class UserOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.accessGroup = _data["accessGroup"] !== undefined ? _data["accessGroup"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["accessGroup"] = this.accessGroup !== undefined ? this.accessGroup : null;
        return data;
    }
}
export class Address {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.street = _data["street"] !== undefined ? _data["street"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street !== undefined ? this.street : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        return data;
    }
}
export class RemotePatientMonitoringProviderOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.remotePatientMonitoringProviderId = _data["remotePatientMonitoringProviderId"] !== undefined ? _data["remotePatientMonitoringProviderId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : null;
            this.contact = _data["contact"] !== undefined ? _data["contact"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemotePatientMonitoringProviderOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["remotePatientMonitoringProviderId"] = this.remotePatientMonitoringProviderId !== undefined ? this.remotePatientMonitoringProviderId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        data["contact"] = this.contact !== undefined ? this.contact : null;
        return data;
    }
}
export class OrganizationOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null;
            this.remotePatientMonitoringProvider = _data["remotePatientMonitoringProvider"] ? RemotePatientMonitoringProviderOutputDto.fromJS(_data["remotePatientMonitoringProvider"]) : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.timeZoneOffset = _data["timeZoneOffset"] !== undefined ? _data["timeZoneOffset"] : null;
            this.organizationChannelId = _data["organizationChannelId"] !== undefined ? _data["organizationChannelId"] : null;
            this.organizationChannelName = _data["organizationChannelName"] !== undefined ? _data["organizationChannelName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        data["remotePatientMonitoringProvider"] = this.remotePatientMonitoringProvider ? this.remotePatientMonitoringProvider.toJSON() : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["timeZoneOffset"] = this.timeZoneOffset !== undefined ? this.timeZoneOffset : null;
        data["organizationChannelId"] = this.organizationChannelId !== undefined ? this.organizationChannelId : null;
        data["organizationChannelName"] = this.organizationChannelName !== undefined ? this.organizationChannelName : null;
        return data;
    }
}
export class OrganizationChannelDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationChannelDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        return data;
    }
}
export class DashboardUserTitleOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardUserTitleOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["type"] = this.type !== undefined ? this.type : null;
        return data;
    }
}
export class PatientStatusType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientStatusTypeId = _data["patientStatusTypeId"] !== undefined ? _data["patientStatusTypeId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatusType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientStatusTypeId"] = this.patientStatusTypeId !== undefined ? this.patientStatusTypeId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null;
        return data;
    }
}
export class CreateDashboardUserResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.user = _data["user"] ? UserOutputDto.fromJS(_data["user"]) : null;
            this.organization = _data["organization"] ? OrganizationOutputDto.fromJS(_data["organization"]) : null;
            this.title = _data["title"] ? DashboardUserTitleOutputDto.fromJS(_data["title"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDashboardUserResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null;
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        data["title"] = this.title ? this.title.toJSON() : null;
        return data;
    }
}
export var ListDashboardUserPropertyOrderBy;
(function (ListDashboardUserPropertyOrderBy) {
    ListDashboardUserPropertyOrderBy["DashboardUserId"] = "DashboardUserId";
    ListDashboardUserPropertyOrderBy["FirstName"] = "FirstName";
    ListDashboardUserPropertyOrderBy["LastName"] = "LastName";
    ListDashboardUserPropertyOrderBy["FullName"] = "FullName";
    ListDashboardUserPropertyOrderBy["Title"] = "Title";
    ListDashboardUserPropertyOrderBy["CreationDate"] = "CreationDate";
    ListDashboardUserPropertyOrderBy["Status"] = "Status";
})(ListDashboardUserPropertyOrderBy || (ListDashboardUserPropertyOrderBy = {}));
export class ListDashboardUsersResultEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.user = _data["user"] ? UserOutputDto.fromJS(_data["user"]) : null;
            this.title = _data["title"] ? DashboardUserTitleOutputDto.fromJS(_data["title"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardUsersResultEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null;
        data["title"] = this.title ? this.title.toJSON() : null;
        return data;
    }
}
export class ListDashboardUsersResultEntryPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ListDashboardUsersResultEntry.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardUsersResultEntryPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class GetDashboardUserInformationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.user = _data["user"] ? UserOutputDto.fromJS(_data["user"]) : null;
            this.organization = _data["organization"] ? OrganizationOutputDto.fromJS(_data["organization"]) : null;
            this.title = _data["title"] ? DashboardUserTitleOutputDto.fromJS(_data["title"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardUserInformationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null;
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        data["title"] = this.title ? this.title.toJSON() : null;
        return data;
    }
}
export class UpdateDashboardUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    }
}
export class DashboardUserConfirmationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.password = _data["password"] !== undefined ? _data["password"] : null;
            this.passwordConfirm = _data["passwordConfirm"] !== undefined ? _data["passwordConfirm"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardUserConfirmationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirm"] = this.passwordConfirm !== undefined ? this.passwordConfirm : null;
        return data;
    }
}
export class OrganizationInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.remotePatientMonitoringProviderId = _data["remotePatientMonitoringProviderId"] !== undefined ? _data["remotePatientMonitoringProviderId"] : null;
            this.timeZoneOffset = _data["timeZoneOffset"] !== undefined ? _data["timeZoneOffset"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.address = _data["address"] !== undefined ? _data["address"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : null;
            this.organizationChannelId = _data["organizationChannelId"] !== undefined ? _data["organizationChannelId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["remotePatientMonitoringProviderId"] = this.remotePatientMonitoringProviderId !== undefined ? this.remotePatientMonitoringProviderId : null;
        data["timeZoneOffset"] = this.timeZoneOffset !== undefined ? this.timeZoneOffset : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["address"] = this.address !== undefined ? this.address : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : null;
        data["organizationChannelId"] = this.organizationChannelId !== undefined ? this.organizationChannelId : null;
        return data;
    }
}
export var ListOrganizationsPropertyOrderBy;
(function (ListOrganizationsPropertyOrderBy) {
    ListOrganizationsPropertyOrderBy["OrganizationId"] = "OrganizationId";
    ListOrganizationsPropertyOrderBy["Name"] = "Name";
    ListOrganizationsPropertyOrderBy["Address"] = "Address";
    ListOrganizationsPropertyOrderBy["State"] = "State";
    ListOrganizationsPropertyOrderBy["Phone"] = "Phone";
    ListOrganizationsPropertyOrderBy["ContactPerson"] = "ContactPerson";
    ListOrganizationsPropertyOrderBy["Email"] = "Email";
    ListOrganizationsPropertyOrderBy["ZipCode"] = "ZipCode";
    ListOrganizationsPropertyOrderBy["City"] = "City";
    ListOrganizationsPropertyOrderBy["CreationDate"] = "CreationDate";
    ListOrganizationsPropertyOrderBy["Deleted"] = "Deleted";
    ListOrganizationsPropertyOrderBy["OrganizationChannel"] = "OrganizationChannel";
})(ListOrganizationsPropertyOrderBy || (ListOrganizationsPropertyOrderBy = {}));
export class OrganizationOutputDtoPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(OrganizationOutputDto.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOutputDtoPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class OrganizationNameDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationNameDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    }
}
export class GetOrpyxCareUserInformationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.user = _data["user"] ? UserOutputDto.fromJS(_data["user"]) : null;
            this.organization = _data["organization"] ? OrganizationOutputDto.fromJS(_data["organization"]) : null;
            this.title = _data["title"] ? DashboardUserTitleOutputDto.fromJS(_data["title"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrpyxCareUserInformationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null;
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        data["title"] = this.title ? this.title.toJSON() : null;
        return data;
    }
}
export class UpdateOrpyxCareUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : null;
            this.accessGroup = _data["accessGroup"] !== undefined ? _data["accessGroup"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrpyxCareUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : null;
        data["accessGroup"] = this.accessGroup !== undefined ? this.accessGroup : null;
        return data;
    }
}
export var ListOrpyxCareUserPropertyOrderBy;
(function (ListOrpyxCareUserPropertyOrderBy) {
    ListOrpyxCareUserPropertyOrderBy["FirstName"] = "FirstName";
    ListOrpyxCareUserPropertyOrderBy["LastName"] = "LastName";
    ListOrpyxCareUserPropertyOrderBy["FullName"] = "FullName";
    ListOrpyxCareUserPropertyOrderBy["Title"] = "Title";
    ListOrpyxCareUserPropertyOrderBy["CreationDate"] = "CreationDate";
    ListOrpyxCareUserPropertyOrderBy["Status"] = "Status";
})(ListOrpyxCareUserPropertyOrderBy || (ListOrpyxCareUserPropertyOrderBy = {}));
export var DashboardRolePermissionFilterDto;
(function (DashboardRolePermissionFilterDto) {
    DashboardRolePermissionFilterDto["All"] = "All";
    DashboardRolePermissionFilterDto["Basic"] = "Basic";
    DashboardRolePermissionFilterDto["AllOrganization"] = "AllOrganization";
})(DashboardRolePermissionFilterDto || (DashboardRolePermissionFilterDto = {}));
export class ListOrpyxCareUsersResultEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.user = _data["user"] ? UserOutputDto.fromJS(_data["user"]) : null;
            this.title = _data["title"] ? DashboardUserTitleOutputDto.fromJS(_data["title"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListOrpyxCareUsersResultEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : null;
        data["title"] = this.title ? this.title.toJSON() : null;
        return data;
    }
}
export class ListOrpyxCareUsersResultEntryPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ListOrpyxCareUsersResultEntry.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListOrpyxCareUsersResultEntryPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export var OrpyxRoleType;
(function (OrpyxRoleType) {
    OrpyxRoleType["OrganizationsAdmin"] = "OrganizationsAdmin";
    OrpyxRoleType["Support"] = "Support";
    OrpyxRoleType["Manufacturing"] = "Manufacturing";
    OrpyxRoleType["Admin"] = "Admin";
    OrpyxRoleType["Audit"] = "Audit";
})(OrpyxRoleType || (OrpyxRoleType = {}));
export class OrpyxRoleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orpyxRoleId = _data["orpyxRoleId"] !== undefined ? _data["orpyxRoleId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.role = _data["role"] !== undefined ? _data["role"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrpyxRoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orpyxRoleId"] = this.orpyxRoleId !== undefined ? this.orpyxRoleId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["role"] = this.role !== undefined ? this.role : null;
        return data;
    }
}
export class AssignedRoleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orpyxUserRoleId = _data["orpyxUserRoleId"] !== undefined ? _data["orpyxUserRoleId"] : null;
            this.role = _data["role"] ? OrpyxRoleDto.fromJS(_data["role"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedRoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orpyxUserRoleId"] = this.orpyxUserRoleId !== undefined ? this.orpyxUserRoleId : null;
        data["role"] = this.role ? this.role.toJSON() : null;
        return data;
    }
}
export class OrpyxUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orpyxUserId = _data["orpyxUserId"] !== undefined ? _data["orpyxUserId"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(AssignedRoleDto.fromJS(item));
            }
            else {
                this.roles = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrpyxUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orpyxUserId"] = this.orpyxUserId !== undefined ? this.orpyxUserId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}
export class CreateOrpyxUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
            else {
                this.roles = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrpyxUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}
export var ListOrpyxUserPropertyOrderBy;
(function (ListOrpyxUserPropertyOrderBy) {
    ListOrpyxUserPropertyOrderBy["OrpyxUserId"] = "OrpyxUserId";
    ListOrpyxUserPropertyOrderBy["CreationDate"] = "CreationDate";
    ListOrpyxUserPropertyOrderBy["Email"] = "Email";
    ListOrpyxUserPropertyOrderBy["FirstName"] = "FirstName";
    ListOrpyxUserPropertyOrderBy["LastName"] = "LastName";
    ListOrpyxUserPropertyOrderBy["FullName"] = "FullName";
    ListOrpyxUserPropertyOrderBy["Status"] = "Status";
})(ListOrpyxUserPropertyOrderBy || (ListOrpyxUserPropertyOrderBy = {}));
export class OrpyxUserDtoPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(OrpyxUserDto.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrpyxUserDtoPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class UpdateOrpyxUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrpyxUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    }
}
export class AssignOrpyxUserRolesResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orpyxUser = _data["orpyxUser"] ? OrpyxUserDto.fromJS(_data["orpyxUser"]) : null;
            this.assignedRole = _data["assignedRole"] ? AssignedRoleDto.fromJS(_data["assignedRole"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignOrpyxUserRolesResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orpyxUser"] = this.orpyxUser ? this.orpyxUser.toJSON() : null;
        data["assignedRole"] = this.assignedRole ? this.assignedRole.toJSON() : null;
        return data;
    }
}
export class RevokeOrpyxUserRoleResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orpyxUser = _data["orpyxUser"] ? OrpyxUserDto.fromJS(_data["orpyxUser"]) : null;
            this.revokedRole = _data["revokedRole"] ? OrpyxRoleDto.fromJS(_data["revokedRole"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeOrpyxUserRoleResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orpyxUser"] = this.orpyxUser ? this.orpyxUser.toJSON() : null;
        data["revokedRole"] = this.revokedRole ? this.revokedRole.toJSON() : null;
        return data;
    }
}
export class CreateProductWith2InsolesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
            this.productReleaseDate = _data["productReleaseDate"] ? moment(_data["productReleaseDate"].toString()) : null;
            this.leftInsoleSerialNumber = _data["leftInsoleSerialNumber"] !== undefined ? _data["leftInsoleSerialNumber"] : null;
            this.rightInsoleSerialNumber = _data["rightInsoleSerialNumber"] !== undefined ? _data["rightInsoleSerialNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductWith2InsolesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        data["productReleaseDate"] = this.productReleaseDate ? this.productReleaseDate.toISOString() : null;
        data["leftInsoleSerialNumber"] = this.leftInsoleSerialNumber !== undefined ? this.leftInsoleSerialNumber : null;
        data["rightInsoleSerialNumber"] = this.rightInsoleSerialNumber !== undefined ? this.rightInsoleSerialNumber : null;
        return data;
    }
}
export class CreateProductResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null;
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
            this.leftInsoleSerialNumber = _data["leftInsoleSerialNumber"] !== undefined ? _data["leftInsoleSerialNumber"] : null;
            this.rightInsoleSerialNumber = _data["rightInsoleSerialNumber"] !== undefined ? _data["rightInsoleSerialNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null;
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        data["leftInsoleSerialNumber"] = this.leftInsoleSerialNumber !== undefined ? this.leftInsoleSerialNumber : null;
        data["rightInsoleSerialNumber"] = this.rightInsoleSerialNumber !== undefined ? this.rightInsoleSerialNumber : null;
        return data;
    }
}
export class InsolesListEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.insoleId = _data["insoleId"] !== undefined ? _data["insoleId"] : null;
            this.insoleSerialNumber = _data["insoleSerialNumber"] !== undefined ? _data["insoleSerialNumber"] : null;
            this.isLeft = _data["isLeft"] !== undefined ? _data["isLeft"] : null;
            this.isRight = _data["isRight"] !== undefined ? _data["isRight"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InsolesListEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["insoleId"] = this.insoleId !== undefined ? this.insoleId : null;
        data["insoleSerialNumber"] = this.insoleSerialNumber !== undefined ? this.insoleSerialNumber : null;
        data["isLeft"] = this.isLeft !== undefined ? this.isLeft : null;
        data["isRight"] = this.isRight !== undefined ? this.isRight : null;
        return data;
    }
}
export class ListProductsResultEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null;
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
            this.productReleaseDate = _data["productReleaseDate"] ? moment(_data["productReleaseDate"].toString()) : null;
            if (Array.isArray(_data["insoles"])) {
                this.insoles = [];
                for (let item of _data["insoles"])
                    this.insoles.push(InsolesListEntry.fromJS(item));
            }
            else {
                this.insoles = null;
            }
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductsResultEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null;
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        data["productReleaseDate"] = this.productReleaseDate ? this.productReleaseDate.toISOString() : null;
        if (Array.isArray(this.insoles)) {
            data["insoles"] = [];
            for (let item of this.insoles)
                data["insoles"].push(item.toJSON());
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        return data;
    }
}
export class PatientOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.clientPatientIdentifier = _data["clientPatientIdentifier"] !== undefined ? _data["clientPatientIdentifier"] : null;
            this.remotePatientMonitoringPatientId = _data["remotePatientMonitoringPatientId"] !== undefined ? _data["remotePatientMonitoringPatientId"] : null;
            this.dateOfPatientAuthorization = _data["dateOfPatientAuthorization"] ? moment(_data["dateOfPatientAuthorization"].toString()) : null;
            this.contactPhonerNumber = _data["contactPhonerNumber"] !== undefined ? _data["contactPhonerNumber"] : null;
            this.mobileObjectId = _data["mobileObjectId"] !== undefined ? _data["mobileObjectId"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.lastStatusUpdatedAt = _data["lastStatusUpdatedAt"] ? moment(_data["lastStatusUpdatedAt"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["clientPatientIdentifier"] = this.clientPatientIdentifier !== undefined ? this.clientPatientIdentifier : null;
        data["remotePatientMonitoringPatientId"] = this.remotePatientMonitoringPatientId !== undefined ? this.remotePatientMonitoringPatientId : null;
        data["dateOfPatientAuthorization"] = this.dateOfPatientAuthorization ? this.dateOfPatientAuthorization.toISOString() : null;
        data["contactPhonerNumber"] = this.contactPhonerNumber !== undefined ? this.contactPhonerNumber : null;
        data["mobileObjectId"] = this.mobileObjectId !== undefined ? this.mobileObjectId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["lastStatusUpdatedAt"] = this.lastStatusUpdatedAt ? this.lastStatusUpdatedAt.toISOString() : null;
        return data;
    }
}
export class GetPatientInformationResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patient = _data["patient"] ? PatientOutputDto.fromJS(_data["patient"]) : null;
            this.organization = _data["organization"] ? OrganizationOutputDto.fromJS(_data["organization"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientInformationResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : null;
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        return data;
    }
}
export var GetPatientsListPropertyOrderBy;
(function (GetPatientsListPropertyOrderBy) {
    GetPatientsListPropertyOrderBy["PatientId"] = "PatientId";
    GetPatientsListPropertyOrderBy["FirstName"] = "FirstName";
    GetPatientsListPropertyOrderBy["LastName"] = "LastName";
    GetPatientsListPropertyOrderBy["NamesPair"] = "NamesPair";
    GetPatientsListPropertyOrderBy["Deleted"] = "Deleted";
    GetPatientsListPropertyOrderBy["CreatedAt"] = "CreatedAt";
    GetPatientsListPropertyOrderBy["Organization"] = "Organization";
    GetPatientsListPropertyOrderBy["ClientPatientIdentifier"] = "ClientPatientIdentifier";
    GetPatientsListPropertyOrderBy["Status"] = "Status";
    GetPatientsListPropertyOrderBy["LastStatusUpdatedAt"] = "LastStatusUpdatedAt";
})(GetPatientsListPropertyOrderBy || (GetPatientsListPropertyOrderBy = {}));
export class GetPatientsListResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patient = _data["patient"] ? PatientOutputDto.fromJS(_data["patient"]) : null;
            this.organization = _data["organization"] ? OrganizationNameDto.fromJS(_data["organization"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsListResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient ? this.patient.toJSON() : null;
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        return data;
    }
}
export class GetPatientsListResultPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(GetPatientsListResult.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsListResultPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class CreatePatientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.clientPatientIdentifier = _data["clientPatientIdentifier"] !== undefined ? _data["clientPatientIdentifier"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.remotePatientMonitoringPatientId = _data["remotePatientMonitoringPatientId"] !== undefined ? _data["remotePatientMonitoringPatientId"] : null;
            this.contactPhoneNumber = _data["contactPhoneNumber"] !== undefined ? _data["contactPhoneNumber"] : null;
            this.dateOfPatientAuthorization = _data["dateOfPatientAuthorization"] ? moment(_data["dateOfPatientAuthorization"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["clientPatientIdentifier"] = this.clientPatientIdentifier !== undefined ? this.clientPatientIdentifier : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["remotePatientMonitoringPatientId"] = this.remotePatientMonitoringPatientId !== undefined ? this.remotePatientMonitoringPatientId : null;
        data["contactPhoneNumber"] = this.contactPhoneNumber !== undefined ? this.contactPhoneNumber : null;
        data["dateOfPatientAuthorization"] = this.dateOfPatientAuthorization ? this.dateOfPatientAuthorization.toISOString() : null;
        return data;
    }
}
export class UpdatePatientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            this.clientPatientIdentifier = _data["clientPatientIdentifier"] !== undefined ? _data["clientPatientIdentifier"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.remotePatientMonitoringPatientId = _data["remotePatientMonitoringPatientId"] !== undefined ? _data["remotePatientMonitoringPatientId"] : null;
            this.dateOfPatientAuthorization = _data["dateOfPatientAuthorization"] ? moment(_data["dateOfPatientAuthorization"].toString()) : null;
            this.contactPhoneNumber = _data["contactPhoneNumber"] !== undefined ? _data["contactPhoneNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        data["clientPatientIdentifier"] = this.clientPatientIdentifier !== undefined ? this.clientPatientIdentifier : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["remotePatientMonitoringPatientId"] = this.remotePatientMonitoringPatientId !== undefined ? this.remotePatientMonitoringPatientId : null;
        data["dateOfPatientAuthorization"] = this.dateOfPatientAuthorization ? this.dateOfPatientAuthorization.toISOString() : null;
        data["contactPhoneNumber"] = this.contactPhoneNumber !== undefined ? this.contactPhoneNumber : null;
        return data;
    }
}
export class FileResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["content"] = this.content !== undefined ? this.content : null;
        return data;
    }
}
export var ActorType;
(function (ActorType) {
    ActorType["DashboardUser"] = "DashboardUser";
    ActorType["OrpyxUser"] = "OrpyxUser";
    ActorType["RPM"] = "RPM";
})(ActorType || (ActorType = {}));
export var PhiAccessType;
(function (PhiAccessType) {
    PhiAccessType["Got"] = "Got";
    PhiAccessType["Listed"] = "Listed";
    PhiAccessType["Deleted"] = "Deleted";
    PhiAccessType["Updated"] = "Updated";
    PhiAccessType["Created"] = "Created";
    PhiAccessType["Restored"] = "Restored";
})(PhiAccessType || (PhiAccessType = {}));
export var GenerateReportPatientOptions;
(function (GenerateReportPatientOptions) {
    GenerateReportPatientOptions["ContainsPatientIdentifier"] = "ContainsPatientIdentifier";
    GenerateReportPatientOptions["EqualPatientIdentifier"] = "EqualPatientIdentifier";
})(GenerateReportPatientOptions || (GenerateReportPatientOptions = {}));
export class UpdateProductDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
            this.productReleaseDate = _data["productReleaseDate"] ? moment(_data["productReleaseDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        data["productReleaseDate"] = this.productReleaseDate ? this.productReleaseDate.toISOString() : null;
        return data;
    }
}
export class UpdateProductResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        return data;
    }
}
export class AddInsoleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isLeft = _data["isLeft"] !== undefined ? _data["isLeft"] : null;
            this.insoleSerialNumber = _data["insoleSerialNumber"] !== undefined ? _data["insoleSerialNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddInsoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isLeft"] = this.isLeft !== undefined ? this.isLeft : null;
        data["insoleSerialNumber"] = this.insoleSerialNumber !== undefined ? this.insoleSerialNumber : null;
        return data;
    }
}
export class AddInsoleResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.insoleSerialNumber = _data["insoleSerialNumber"] !== undefined ? _data["insoleSerialNumber"] : null;
            this.isLeft = _data["isLeft"] !== undefined ? _data["isLeft"] : null;
            this.isRight = _data["isRight"] !== undefined ? _data["isRight"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddInsoleResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["insoleSerialNumber"] = this.insoleSerialNumber !== undefined ? this.insoleSerialNumber : null;
        data["isLeft"] = this.isLeft !== undefined ? this.isLeft : null;
        data["isRight"] = this.isRight !== undefined ? this.isRight : null;
        return data;
    }
}
export class RemoveInsoleResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null;
            this.insoleId = _data["insoleId"] !== undefined ? _data["insoleId"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveInsoleResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null;
        data["insoleId"] = this.insoleId !== undefined ? this.insoleId : null;
        return data;
    }
}
export class SearchPatientInsolesResponseEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.insoleId = _data["insoleId"] !== undefined ? _data["insoleId"] : null;
            this.insoleSerialNumber = _data["insoleSerialNumber"] !== undefined ? _data["insoleSerialNumber"] : null;
            this.productSerialNumber = _data["productSerialNumber"] !== undefined ? _data["productSerialNumber"] : null;
            this.isLeft = _data["isLeft"] !== undefined ? _data["isLeft"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPatientInsolesResponseEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["insoleId"] = this.insoleId !== undefined ? this.insoleId : null;
        data["insoleSerialNumber"] = this.insoleSerialNumber !== undefined ? this.insoleSerialNumber : null;
        data["productSerialNumber"] = this.productSerialNumber !== undefined ? this.productSerialNumber : null;
        data["isLeft"] = this.isLeft !== undefined ? this.isLeft : null;
        return data;
    }
}
export class RemotePatientMonitoringProviderInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.address = _data["address"] !== undefined ? _data["address"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.contact = _data["contact"] !== undefined ? _data["contact"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemotePatientMonitoringProviderInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["address"] = this.address !== undefined ? this.address : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["contact"] = this.contact !== undefined ? this.contact : null;
        return data;
    }
}
export var SearchRemotePatientMonitoringProvidersOrderBy;
(function (SearchRemotePatientMonitoringProvidersOrderBy) {
    SearchRemotePatientMonitoringProvidersOrderBy["RemotePatientMonitoringProviderId"] = "RemotePatientMonitoringProviderId";
    SearchRemotePatientMonitoringProvidersOrderBy["Name"] = "Name";
})(SearchRemotePatientMonitoringProvidersOrderBy || (SearchRemotePatientMonitoringProvidersOrderBy = {}));
export class RemotePatientMonitoringProviderOutputDtoPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RemotePatientMonitoringProviderOutputDto.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemotePatientMonitoringProviderOutputDtoPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
